module.exports = __webpack_public_path__ + "img/16.961634ef.jpg";